import { Component, Input, OnInit } from '@angular/core';
import { InteractiveWidget } from '@marketing/interactive-widgets/interactive-widgets.interface';
import { AbstractBaseComponent } from '@shared/abstract-base/abstract-base.component';
import { ProfileService, WidenService } from '@services';
import { Component as BrComponent, Page } from '@bloomreach/spa-sdk';
import { InteractiveWidgetServiceService } from '@marketing/interactive-widgets/interactive-widget-service.service';

@Component({
  selector: 'ft-interactive-widgets',
  templateUrl: './interactive-widgets.component.html',
  styleUrls: ['./interactive-widgets.component.scss'],
})
export class InteractiveWidgetsComponent
  extends AbstractBaseComponent
  implements OnInit {
  @Input() myDashboardComponent?: BrComponent;
  @Input() myDashboardPage?: Page;
  public interactiveWidgets: Array<InteractiveWidget>;
  public isBypassUser: boolean;

  constructor(
    private widenService: WidenService,
    private profileService: ProfileService,
    private interactiveWidgetServiceService: InteractiveWidgetServiceService
  ) {
    super();
  }

  ngOnInit(): void {
    this.interactiveWidgets = this.getInteractiveWidgets() || [];
    this.isBypassUser = this.profileService.isBypass(true);
  }

  /**
   * Get Interactive Widgets array
   */
  private getInteractiveWidgets(): InteractiveWidget[] {
    // Component can be standalone or included in myDashboard
    const component = this.myDashboardComponent
      ? this.myDashboardComponent
      : this.component;
    const page = this.myDashboardPage ? this.myDashboardPage : this.page;

    const interactiveWidgetsModel = component.getModels();
    const interactiveWidgets = page
      .getContent(
        interactiveWidgetsModel.InteractiveWidgets ||
          interactiveWidgetsModel.interactiveWidgets
      )
      ?.getData()?.interactiveWidget;
    interactiveWidgets?.forEach((widget: InteractiveWidget) => {
      widget.imgSrc = this.widenService.getWidenAssetUrl(
        widget.logoImage?.widenAsset
      );
      widget.interactiveConfigImpl = JSON.parse(widget.interactiveConfig);
      widget.isFirmAllowed = this.interactiveWidgetServiceService.getIsFirmAllowed(
        widget.firmName,
        this.profileService.getUserProfile()
      );
      widget.labelsImpl = interactiveWidgetsModel[widget.labels];
    });
    return interactiveWidgets;
  }
}
